import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { SectionTitle } from "@/components/ArticleCards";
import { useI18n } from "@/lib/i18n";

export default function ContentPage({ pageKey, defaultTitle, defaultSubtitle, subtitleKey, fallbackBody, showUpdated }) {
  const { t, lang } = useI18n();
  const [page, setPage] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    // Try locale-specific page first (e.g., about_es), fallback to base
    const tryKey = lang === "es" ? `${pageKey}_es` : pageKey;
    api.get(`/content/${tryKey}`)
      .then((r) => { setPage(r.data); setLoading(false); })
      .catch(() => {
        // fallback to base english
        if (tryKey !== pageKey) {
          api.get(`/content/${pageKey}`).then((r) => { setPage(r.data); setLoading(false); }).catch(() => setLoading(false));
        } else {
          setLoading(false);
        }
      });
  }, [pageKey, lang]);

  return (
    <div className="py-16 md:py-24" data-testid={`content-${pageKey}`}>
      <div className="max-w-3xl mx-auto px-6">
        <SectionTitle subtitle={subtitleKey ? t(subtitleKey) : defaultSubtitle}>
          {page?.title || defaultTitle}
        </SectionTitle>
        {loading ? (
          <div className="text-center font-serif text-[#001F3F]/60">{t("common.loading")}</div>
        ) : (
          <>
            <article className="font-serif text-base text-[#0A1118] leading-relaxed whitespace-pre-line">
              {page?.body || fallbackBody || t("content.coming_soon")}
            </article>
            {showUpdated && page?.updated_at && (
              <div className="mt-8 text-xs font-sans text-gray-500" data-testid="content-last-modified">
                {t("legal.last_modified")}: {new Date(page.updated_at).toLocaleDateString(lang === "es" ? "es-MX" : "en-US", { year: "numeric", month: "long", day: "numeric" })}
              </div>
            )}
          </>
        )}
      </div>
    </div>
  );
}
